import { Text } from "components/common";
import React, { forwardRef, useContext } from "react";
import Bg from "assets/4.png";
import shareBg from "assets/share-4.png";
import { css } from "@emotion/css";
import { CARD_HEIGHT } from "utils/constants";
import { UserContext } from "context";
import { ShareBtn } from "./shareBtn";
import { SharableContent } from "./sharableContent";
import { Footer } from "./footer";

const offset = 50;

type Props = {
  handleNext?: VoidFunction;
  handleShare: (option: 'twitter' | 'facebook' | 'linkedin') => void;
  index: number;
  ref: React.Ref<HTMLDivElement>;
  shareLoading?: boolean;
};
export const TimeSpendInEmailRef = forwardRef<HTMLDivElement, Props>(({index, handleShare, shareLoading}, ref) => {
  const {state: userState} = useContext(UserContext);
  // duration of the movie "You've Got Mail" in minutes
  const youGotMailDuration = 119;
  const time = ((userState?.emailStats?.timeSpendReadingEmail || 0) / youGotMailDuration).toFixed(0);
  const [isShare, setIsShare] = React.useState(false);
        const onShare = (option: 'twitter' | 'facebook' | 'linkedin') => {
          setIsShare(true);
          setTimeout(async () => {
          await handleShare(option);
              setIsShare(false);
          }, 1000);
        };
  return (
    <>
    <div
      data-value={index}
      className={css`
        border: 1.825px solid #29282f;
        height: calc(100vh - ${offset}px);
        max-height: calc(${CARD_HEIGHT}px - ${offset}px);
        width: 100%;
        border-radius: 40px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding: 50px 24px 65px 24px;
        transition: transform 0.3s;
        background: url(${Bg});
        background-repeat: no-repeat;
        background-position: top 0px left 0px;
        background-size: 100% auto;
        background-color: #151419;

        &:hover {
          transform: translateY(1px);
        }
        position: relative;
        overflow: hidden;
      `}
    >
      <Text.Body
        style={{
          marginBottom: "140px",
          marginTop: "5px",
          fontSize: "28px",
          zIndex: 2,
          textAlign: "center",
        }}
      >
        That’s like watching “You’ve Got Mail”{" "}
        <span style={{ color: "#AAEF65" }}>{time} times.</span>
      </Text.Body>
      {shareLoading ? (
                    <Text.Body style={{ fontSize: "28px", zIndex: 2 }}>Sharing...</Text.Body>
                  ) : <ShareBtn handleShare={onShare} />}
    </div>

     {isShare && <SharableContent>
      <div
      ref={ref} 
      className={css`
        width: 560px;
        height: 700px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding: 50px 24px 65px 24px;
        transition: transform 0.3s;
        background: url(${shareBg});
        background-repeat: no-repeat;
        background-position: top 0px left 0px;
        background-size: 100% auto;
        background-color: #151419;
        position: relative;
        overflow: hidden;
      `}
    >

      <Text.Body
            style={{
              marginBottom: "42px",
              marginTop: "5px",
              fontSize: "100px",
              color: "#AAEF65",
              zIndex: 2,
            }}
          >
            {time}
          </Text.Body>
    <Text.Body
      style={{
        marginBottom: "70px",
        marginTop: "5px",
        fontSize: "30px",
        zIndex: 2,
        textAlign: "center",
      }}
    >
      How many times I could’ve watched You’ve got Mail in the time it would have taken me to read all my email.
    </Text.Body>

            <Footer />
      
    </div>
     </SharableContent>}
    </>
  );
});
